import HelperService from "../../../StarterKit/Service/Bll/HelperService";
import ApiExport from "../Api/ApiExport";
import * as XLSX from "xlsx";

export default class ExportService {
    #helper;
    #api;

    constructor() {
        this.#api = new ApiExport();
        this.#helper = new HelperService();
    }

    async getDataToExport(query) {
        const result = await this.#api.getDataToExport(query);
        return result;
    }

    static exportToExcel({data, fileName}) {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Feuille1");
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };
}